import {joinExpressions} from 'common/query-builder/cohorts-query-builder/util/expression-tree';

import {PropertyFilter} from '../builder/property-filter';
import {BehaviorCountType, LogicalOperator} from '../enums/expression-enums';
import {OperatorNode} from '../expression/operator-node';
import {Serializable, SerializedBehaviorCount} from '../types/serialized-cohort-types';
import {EventSelector} from './event-selector';

export class BehaviorCount implements Serializable {
  public static parseBehaviorCount(serializedCount: SerializedBehaviorCount): BehaviorCount {
    if (!serializedCount) {
      return null;
    }

    return new BehaviorCount(
      new EventSelector(
        serializedCount.event_selector.event,
        OperatorNode.parseExpression(serializedCount.event_selector.selector) as OperatorNode,
      ),
      serializedCount.type,
    );
  }

  constructor(public eventSelector: EventSelector, public type: BehaviorCountType) {}

  public getEventValue(): string {
    return this.eventSelector.event;
  }

  public setEventSelector(propertyFilters: PropertyFilter[], operator: LogicalOperator): BehaviorCount {
    let selector = null;
    if (propertyFilters.length) {
      const propertyFilterTrees = propertyFilters.map((clause) => clause.getExpressionTree());
      selector = joinExpressions(propertyFilterTrees, operator);
    }

    return new BehaviorCount(new EventSelector(this.eventSelector.event, selector), this.type);
  }

  public serialize(): SerializedBehaviorCount {
    return {
      event_selector: this.eventSelector.serialize(),
      type: this.type,
    };
  }
}
